const allPersonalizeFonts = (limit = 10) => [
  {
    id: 0,
    name: 'Apolline',
    img: 'https://cdn.shopify.com/s/files/1/1556/0287/files/Annie.png?v=1694064566',
    selected: true,
    limit,
    lowercase: false,
    url: '//globite.com/cdn/shop/t/71/assets/Apolline-Regular.woff2?v=91253641242193782921714536500',
    weight: 400,
    localUrl: '../../assets/Apolline-Regular.woff',
  },
  {
    id: 1,
    name: 'Bungee',
    img: 'https://cdn.shopify.com/s/files/1/1556/0287/files/Bungee.png?v=1694064578',
    selected: false,
    limit,
    lowercase: false,
    url: '//globite.com/cdn/shop/t/71/assets/Bungee-Regular.woff2?v=96252508786060850551714536500',
    weight: 400,
    localUrl: '../../assets/Bungee-Regular.woff2',
  },
  {
    id: 2,
    name: 'Chewy',
    img: 'https://cdn.shopify.com/s/files/1/1556/0287/files/Chewy.png?v=1694064589',
    selected: false,
    limit,
    lowercase: false,
    url: '//globite.com/cdn/shop/t/71/assets/Chewy-Regular.woff2?v=1996634745374990721714536500',
    weight: 400,
    localUrl: '../../assets/Chewy-Regular.woff2',
  },
  {
    id: 3,
    name: 'Freshman',
    img: 'https://cdn.shopify.com/s/files/1/1556/0287/files/Eighties.png?v=1694064599',
    selected: false,
    limit,
    lowercase: false,
    url: '//globite.com/cdn/shop/t/71/assets/Freshman.woff2?v=143816994169129323511714536500',
    weight: 400,
    localUrl: '../../assets/Freshman.woff2',
  },
  {
    id: 4,
    name: 'Pacifico',
    img: 'https://cdn.shopify.com/s/files/1/1556/0287/files/Pacifico.png?v=1694064614',
    selected: false,
    limit,
    lowercase: false,
    url: '//globite.com/cdn/shop/t/71/assets/Pacifico-Regular.woff2?v=33788904018720742251714536500',
    weight: 400,
    localUrl: '../../assets/Pacifico-Regular.woff2',
  },
  {
    id: 5,
    name: 'OpenSans',
    img: 'https://cdn.shopify.com/s/files/1/1556/0287/files/Open_Sans.png?v=1694064631',
    selected: false,
    limit,
    lowercase: false,
    url: '//globite.com/cdn/shop/t/71/assets/OpenSans-Bold.woff2?v=58256630306571878921714536500',
    weight: 700,
    localUrl: '../../assets/OpenSans-Bold.woff2',
  },
];

const allPersonalizeColors = [
  {
    id: 0,
    name: 'Jazzberry Jam',
    hex: '#a61452',
    rgb: 'rgb(166, 20, 82)',
    selected: false,
    shadowSelected: true,
  },
  {
    id: 1,
    name: 'Cinnamon Satin',
    hex: '#c7627a',
    rgb: 'rgb(199, 98, 122)',
    selected: true,
    shadowSelected: false,
  },
  {
    id: 2,
    name: 'American Pink',
    hex: '#fb8f94',
    rgb: 'rgb(251, 143, 148)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 3,
    name: 'Tuscany',
    hex: '#cc9d9d',
    rgb: 'rgb(204, 157, 157)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 4,
    name: 'Fuzzy Wuzzy',
    hex: '#cd6961',
    rgb: 'rgb(205, 105, 97)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 5,
    name: 'Cordovan',
    hex: '#934b4f',
    rgb: 'rgb(147, 75, 79)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 6,
    name: 'Vivid Auburn',
    hex: '#982c29',
    rgb: 'rgb(152, 44, 41)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 7,
    name: 'Bole',
    hex: '#7e3b35',
    rgb: 'rgb(126, 59, 53)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 8,
    name: 'Cinnabar',
    hex: '#d54734',
    rgb: 'rgb(213, 71, 52)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 9,
    name: 'Tart Orange',
    hex: '#ff4c49',
    rgb: 'rgb(255, 76, 73)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 10,
    name: 'Smashed Pumpkin',
    hex: '#fa693f',
    rgb: 'rgb(250, 105, 63)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 11,
    name: 'Meat Brown',
    hex: '#eea73c',
    rgb: 'rgb(238, 167, 60)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 12,
    name: 'Deep Peach',
    hex: '#f9c5a2',
    rgb: 'rgb(249, 197, 162)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 13,
    name: 'Tan',
    hex: '#d8a378',
    rgb: 'rgb(216, 163, 120)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 14,
    name: 'Gold',
    hex: '#e7bf94',
    rgb: 'rgb(231, 191, 148)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 15,
    name: 'Almond ',
    hex: '#e9dacd',
    rgb: 'rgb(233, 218, 205)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 16,
    name: 'Green',
    hex: '#5d8637',
    rgb: 'rgb(93, 134, 55)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 17,
    name: 'Olive Green',
    hex: '#a7ae54',
    rgb: 'rgb(167, 174, 84)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 18,
    name: ' June Bud',
    hex: '#bad055',
    rgb: 'rgb(186, 208, 85)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 19,
    name: 'Lemon Meringue',
    hex: '#f6e6c3',
    rgb: 'rgb(246, 230, 195)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 20,
    name: 'Spring Bud',
    hex: '#cec980',
    rgb: 'rgb(206, 201, 128)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 21,
    name: 'Laurel Green',
    hex: '#a8be8f',
    rgb: 'rgb(168, 190, 143)',
    selected: false,
    shadowSelected: false,
  },

  {
    id: 22,
    name: 'Dark Silver',
    hex: '#707862',
    rgb: 'rgb(112, 120, 98)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 23,
    name: 'Bangladesh Green',
    hex: '#005c55',
    rgb: 'rgb(0, 92, 85)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 24,
    name: 'Dolphin Gray',
    hex: '#858e89',
    rgb: 'rgb(133, 142, 137)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 25,
    name: 'Chinese Silver',
    hex: '#cbccc9',
    rgb: 'rgb(203, 204, 201)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 26,
    name: 'Alice Blue',
    hex: '#f1f3ff',
    rgb: 'rgb(241, 243, 255)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 27,
    name: 'Pastel Blue',
    hex: '#aac1c7',
    rgb: 'rgb(170, 193, 199)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 28,
    name: 'Blue (Munsell)',
    hex: '#009dab',
    rgb: 'rgb(0, 157, 171)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 29,
    name: 'Steel Blue',
    hex: '#3391ab',
    rgb: 'rgb(51, 145, 171)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 30,
    name: 'USAFA Blue',
    hex: '#00519a',
    rgb: 'rgb(0, 81, 154)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 31,
    name: 'Indigo (Rainbow)',
    hex: '#203e64',
    rgb: 'rgb(32, 62, 100)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 32,
    name: 'Rocket Metallic',
    hex: '#867d84',
    rgb: 'rgb(134, 125, 132)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 33,
    name: 'Deep Amethyst',
    hex: '#938c9f',
    rgb: 'rgb(147, 140, 159)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 34,
    name: 'Nickel',
    hex: '#737075',
    rgb: 'rgb(115, 112, 117)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 35,
    name: 'Dark Electric Blue',
    hex: '#556876',
    rgb: 'rgb(85, 104, 118)',
    selected: false,
    shadowSelected: false,
  },

  {
    id: 36,
    name: 'Charcoal',
    hex: '#32364a',
    rgb: 'rgb(50, 54, 74)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 37,
    name: 'Dark Charcoal',
    hex: '#2f3135',
    rgb: 'rgb(47, 49, 53)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 38,
    name: 'Pine Tree',
    hex: '#293029',
    rgb: 'rgb(41, 48, 41)',
    selected: false,
    shadowSelected: false,
  },
  {
    id: 39,
    name: 'Black',
    hex: '#000000',
    rgb: 'rgb(0, 0, 0)',
    selected: false,
    shadowSelected: false,
  },
];

/**
 * Global Emoji Config
 */
const emojiDirectory = 'https://awaytravel-dev.myshopify.com/cdn/shop/t/5/assets/';
function generateEmojiCode(filename) {
  // Remove the file extension (.svg)
  let emojiCode = filename.replace(/\..+$/, '');

  // Remove any prefix/suffix or other transformations needed
  // Example: If your filenames are like "emoji-001.svg", you can remove "emoji-" as a prefix
  emojiCode = emojiCode.replace(/^emoji-/, '');

  return emojiCode || 'unknown'; // Use 'unknown' or any default code if no valid code is generated.
}
let textEmoji = [];
let textEmojiUnicode = [];
let emojiUrls = [];
function filterText(textValue) {
  textEmoji = [];
  textEmojiUnicode = [];
  emojiUrls = [];
  let result = [];
  let index = 0;

  const parsed = window.twemoji.parse(textValue, {
    callback: (icon, options) => {
      const emojiCode = generateEmojiCode(icon);
      if (emojiCode === 'unknown') {
        return ''; // Skip invalid emoji codes
      }
      const normalizedEmojiCode = emojiCode.replaceAll('-', ' ').toUpperCase();
      const shortcode = findShortcodeByCodePoint(normalizedEmojiCode);
      if (shortcode) {
        textEmoji.push(`-${shortcode}-`);
      }

      textEmojiUnicode.push(normalizedEmojiCode);

      // remove out U+200D and any other variation selector (U+FE0F)
      const customEmojiURL = `${emojiDirectory}${emojiCode
        .replaceAll('-200d', '')
        .replaceAll('-fe0f', '')}.svg?name=:${shortcode}:`;

      emojiUrls.push(customEmojiURL);

      return customEmojiURL;
    },
  });
  // Process the parsed result
  parsed.split(/((?:<img[^>]+>)|(?:[^<]+))/g).forEach((part, key) => {
    if (part.startsWith('<img')) {
      // This part is already processed as an emoji
      result.push({ type: 'emoji', url: emojiUrls[index++], index: key });
    } else if (part.trim() !== '') {
      // This is regular text (ignoring empty strings)
      result.push({ type: 'text', content: part, index: key });
    }
  });

  console.log({ textEmoji, textEmojiUnicode, emojiUrls });
  return result;
}

const StringUtils = {
  isLetter(char) {
    const asciiCode = char.charCodeAt();
    return (asciiCode >= 65 && asciiCode <= 90) || (asciiCode >= 97 && asciiCode <= 122);
  },
  letters(str = '') {
    return str.split('').filter(this.isLetter).join('');
  },
  limit(str, limit = 3) {
    return str.slice(0, limit);
  },
  lettersWithLimit(str = '', limit = 3) {
    return this.limit(this.letters(str), limit);
  },
};

function rgbToRgba(rgb, alpha = 0.6) {
  if (!rgb) {
    return;
  }
  const rgbValues = rgb.match(/\d+/g);

  if (rgbValues && rgbValues.length === 3) {
    return `rgba(${rgbValues[0]},${rgbValues[1]},${rgbValues[2]},${alpha})`;
  }
}

const CheckmarkIcon = {
  template: `
    <svg class="checkmark-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
      <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"></path>
    </svg>
  `,
};

const DotIcon = {
  template: `
  <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 512 512"
      style="border-radius: 50%; fill: rgb(255, 255, 255)"
  >
    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"></path>
  </svg>`,
};

const CircleIcon = {
  template: `
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 512 512"  
    >
    <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 48c110.5 0 200 89.5 200 200 0 110.5-89.5 200-200 200-110.5 0-200-89.5-200-200 0-110.5 89.5-200 200-200m140.2 130.3l-22.5-22.7c-4.7-4.7-12.3-4.7-17-.1L215.3 303.7l-59.8-60.3c-4.7-4.7-12.3-4.7-17-.1l-22.7 22.5c-4.7 4.7-4.7 12.3-.1 17l90.8 91.5c4.7 4.7 12.3 4.7 17 .1l172.6-171.2c4.7-4.7 4.7-12.3 .1-17z"/>
  </svg>
  `,
};
